import clsx from "clsx";
import React from "react";

import style from "./RatingStar.module.scss";

type RatingStarProps = {
  indexTitle?: string;
  title: JSX.Element;
  scoreNum?: number;
  selectedScore: number;
  onRating: (index: number) => void;
};

const RatingStar: React.FC<RatingStarProps> = ({
  indexTitle,
  title,
  selectedScore,
  scoreNum = 4,
  onRating,
}) => {
  const [hoveredScore, setHoveredScore] = React.useState<number>(0);

  return (
    <div className={clsx(style.wrapper, "row")}>
      <div className="col-5">
        <div className={clsx(style.title, "d-flex align-items-center h-100")}>
          {indexTitle && <span>{indexTitle}.</span>}
          <span>{title}</span>
        </div>
      </div>
      <div className="col-7 d-flex align-items-center flex-column">
        <div className={style.score}>
          {[...Array(scoreNum)].map((_, index) => {
            index += 1;
            return (
              <button
                type="button"
                key={index}
                className={
                  index <= (hoveredScore || selectedScore)
                    ? style.on
                    : style.off
                }
                onClick={() => {
                  if (selectedScore === index) {
                    onRating(0);
                  } else {
                    onRating(index);
                  }
                }}
                onMouseEnter={() => setHoveredScore(index)}
                onMouseLeave={() => setHoveredScore(selectedScore)}
              >
                <span className={style.star}>&#9733;</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RatingStar;
